import { $ as e, A as t, C as n, F as r, S as i, U as a, _ as o, d as s, f as c, g as l, h as u, i as d, m as f, nt as p, ot as m, p as h, q as g, t as _, v, w as y } from "./_plugin-vue_export-helper-CTQVpqU-.js";
import { t as b } from "./i18n-lite-BcmwMblk.js";
import { t as x } from "./normalize-props-DNjMoRjC.js";
import { t as S } from "./shadow-dom-9FbsLIC0.js";
import { n as C, t as w } from "./Icon.ce-CkLZiCcP.js";
import { n as T, t as E } from "./Modal.ce-CIjVVUkd.js";
//#region src/webcomponents/autocompletion-mdp/locales/de-AT.json
var D = {}, O = {}, k = {}, A = {}, j = {}, M = { "autocompletion-mdp": {
	title: "Connexion",
	"label-email": "Adresse mail",
	"label-password": "Mot de passe",
	connect: "Se connecter",
	forgot: "Mot de passe oublié ?",
	"a11y-info": "le menu d'auto-completion de votre gestionnaire de mot de passe est disponible. Appuyez sur flèche du bas pour le sélectionner.",
	vault: {
		url: "www.toptracteur.pix.org",
		email: "elio@pixmail.org",
		placeholder: "mon-email@pixmail.org"
	},
	button: {
		"email-label": "Remplir le champ adresse mail avec la valeur: elio@pixmail.org",
		"password-label": "Remplir le champ mot de passe avec la valeur enregistrée",
		label: "Remplir"
	},
	feedback: {
		title: "Bravo !",
		content: "Grâce à une extension de navigateur proposée par le gestionnaire de mots de passe, vous pouvez vous connecter facilement en remplissant automatiquement les champs d'identification."
	}
} }, N = {}, P = {}, F = {}, I = {}, L = {}, R = {}, z = {}, B = { "unavailable-feature": {
	title: "Fonctionnalité désactivée",
	content: "Vous n'avez pas accès à cette fonctionnalité.",
	close: "Fermer"
} }, V = {}, H = {}, U = "data:image/svg+xml,%3csvg%20width='18'%20height='18'%20viewBox='0%200%2018%2018'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M8.99976%2011.25V12.75M4.49976%2015.75H13.4998C13.8976%2015.75%2014.2791%2015.592%2014.5604%2015.3107C14.8417%2015.0294%2014.9998%2014.6478%2014.9998%2014.25V9.75C14.9998%209.35218%2014.8417%208.97064%2014.5604%208.68934C14.2791%208.40804%2013.8976%208.25%2013.4998%208.25H4.49976C4.10193%208.25%203.7204%208.40804%203.4391%208.68934C3.15779%208.97064%202.99976%209.35218%202.99976%209.75V14.25C2.99976%2014.6478%203.15779%2015.0294%203.4391%2015.3107C3.7204%2015.592%204.10193%2015.75%204.49976%2015.75ZM11.9998%208.25V5.25C11.9998%204.45435%2011.6837%203.69129%2011.1211%203.12868C10.5585%202.56607%209.79541%202.25%208.99976%202.25C8.20411%202.25%207.44104%202.56607%206.87844%203.12868C6.31583%203.69129%205.99976%204.45435%205.99976%205.25V8.25H11.9998Z'%20stroke='white'%20stroke-width='1.5'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", W = /* @__PURE__ */ y({
	__name: "UnavailableFeatureModal.ce",
	props: { show: { type: Boolean } },
	emits: ["close"],
	setup(e) {
		return (t, a) => (r(), l(E, {
			loop: !0,
			show: e.show
		}, {
			title: g(() => [i(m(t.$t("unavailable-feature.title")), 1)]),
			content: g(() => [i(m(t.$t("unavailable-feature.content")), 1)]),
			footer: g(() => [n(C, { onClick: a[0] ||= (e) => t.$emit("close") }, {
				default: g(() => [i(m(t.$t("unavailable-feature.close")), 1)]),
				_: 1
			})]),
			_: 1
		}, 8, ["show"]));
	}
}), G = { "aria-live": "polite" }, K = {
	key: 0,
	class: "sr-only"
}, q = {
	key: 0,
	"aria-labelledby": "dialog-label",
	class: "autocompletion-modal",
	role: "dialog"
}, J = {
	id: "dialog-label",
	class: "autocompletion-modal__url"
}, Y = { class: "autocompletion-modal__identity" }, X = { key: 0 }, Z = /*#__PURE__*/ _(/* @__PURE__ */ y({
	__name: "AutocompletionModal.ce",
	props: {
		valueToFill: { type: String },
		relatedValueToFill: { type: String },
		savedUrl: { type: String },
		buttonAriaLabel: { type: String },
		displayModal: { type: Boolean }
	},
	emits: ["fill-input", "hide-modal"],
	setup(e, { expose: t }) {
		let s = a("buttonFill");
		return t({ buttonFill: s }), (t, a) => (r(), v(h, null, [u("div", G, [e.displayModal ? (r(), v("p", K, m(t.$t("autocompletion-mdp.a11y-info")), 1)) : o("", !0)]), e.displayModal ? (r(), v("div", q, [u("p", J, m(e.savedUrl), 1), u("div", Y, [
			n(w, {
				"background-color": "#bed4ff",
				class: "dialog-label-icon"
			}, {
				default: g(() => [i(m(t.$t("autocompletion-mdp.vault.email").at(0).toUpperCase()), 1)]),
				_: 1
			}),
			u("p", null, [e.relatedValueToFill ? (r(), v("span", X, [i(m(e.relatedValueToFill), 1), a[2] ||= u("br", null, null, -1)])) : o("", !0), i(m(e.valueToFill), 1)]),
			n(C, {
				ref_key: "buttonFill",
				ref: s,
				tabindex: "-1",
				"aria-label": e.buttonAriaLabel,
				variant: "secondary",
				onClick: a[0] ||= c((n) => t.$emit("fill-input", e.valueToFill), ["prevent"]),
				onFocusout: a[1] ||= (e) => t.$emit("hide-modal")
			}, {
				default: g(() => [i(m(t.$t("autocompletion-mdp.button.label")), 1)]),
				_: 1
			}, 8, ["aria-label"])
		])])) : o("", !0)], 64));
	}
}), [["styles", [".autocompletion-modal[data-v-1d7ac28f]{z-index:1;background-color:#fff;border:1px solid #c8cfd9;border-radius:8px;width:100%;margin-top:8px;padding:8px 16px 16px;position:absolute;box-shadow:0 6px 12px #07142e14}.autocompletion-modal__url[data-v-1d7ac28f]{color:#4f6384;margin-bottom:8px}.autocompletion-modal__identity[data-v-1d7ac28f]{align-items:center;gap:16px;display:flex}.autocompletion-modal__identity button[data-v-1d7ac28f]{margin-left:auto}.autocompletion-modal[data-v-1d7ac28f] .rounded-icon{justify-content:center;width:2rem;height:2rem;font-size:1rem;font-weight:700;display:flex}@media (width<=576px){.autocompletion-modal__identity[data-v-1d7ac28f]{flex-wrap:wrap}.autocompletion-modal__identity button[data-v-1d7ac28f]{flex-grow:1;margin-left:0}}"]], ["__scopeId", "data-v-1d7ac28f"]]), Q = { class: "wrapper" }, ee = ["aria-level"], te = ["src"], ne = { class: "wrapper__input" }, re = { class: "wrapper__input" }, ie = /*#__PURE__*/ _(/* @__PURE__ */ y({
	__name: "AutocompletionMdp.ce",
	props: { titleLevel: { type: Number } },
	setup(o, { expose: l }) {
		S();
		function d() {
			_.value = "", y.value = "", b.value = !1, x.value = !1, D.value = !1, O.value = !1;
		}
		let h = a("success-modal"), _ = e(""), y = e(""), b = e(!1), x = e(!1), D = e(!1), O = e(!1), k = a("emailInput"), A = a("passwordInput"), j = a("fillEmailModal"), M = a("fillPasswordModal"), N = f(() => !(_.value && y.value));
		async function P() {
			b.value = !0, await t(), h.value.dialogElement.focus();
		}
		function F() {
			_.value || (x.value = !0, D.value = !1);
		}
		function I() {
			y.value || (x.value = !1, D.value = !0);
		}
		function L(e) {
			e?.relatedTarget !== j?.value?.buttonFill?.buttonElement && (x.value = !1);
		}
		function R(e) {
			e?.relatedTarget !== M?.value?.buttonFill?.buttonElement && (D.value = !1);
		}
		async function z(e) {
			_.value = e, await t(), x.value = !1, k.value.inputField.focus();
		}
		async function B(e) {
			y.value = e, await t(), D.value = !1, A.value.inputField.focus();
		}
		function V() {
			j?.value?.buttonFill?.buttonElement.focus();
		}
		function H() {
			M?.value?.buttonFill?.buttonElement.focus();
		}
		function G() {
			O.value = !O.value;
		}
		return l({ reset: d }), (e, t) => (r(), v("div", Q, [
			u("div", {
				"aria-level": o.titleLevel ?? 2,
				class: "title",
				role: "heading"
			}, [n(w, { "background-color": "#2c75ff" }, {
				default: g(() => [u("img", {
					src: p(U),
					alt: ""
				}, null, 8, te)]),
				_: 1
			}), i(" " + m(e.$t("autocompletion-mdp.title")), 1)], 8, ee),
			u("form", null, [
				u("div", ne, [n(T, {
					ref_key: "emailInput",
					ref: k,
					modelValue: _.value,
					"onUpdate:modelValue": t[0] ||= (e) => _.value = e,
					label: e.$t("autocompletion-mdp.label-email"),
					readonly: !0,
					placeholder: e.$t("autocompletion-mdp.vault.placeholder"),
					type: "text",
					onFocusin: F,
					onFocusout: L,
					onKeydown: s(V, ["down"])
				}, null, 8, [
					"modelValue",
					"label",
					"placeholder"
				]), n(Z, {
					ref_key: "fillEmailModal",
					ref: j,
					"display-modal": x.value,
					"saved-url": e.$t("autocompletion-mdp.vault.url"),
					"value-to-fill": e.$t("autocompletion-mdp.vault.email"),
					"button-aria-label": e.$t("autocompletion-mdp.button.email-label"),
					onFillInput: z,
					onHideModal: L
				}, null, 8, [
					"display-modal",
					"saved-url",
					"value-to-fill",
					"button-aria-label"
				])]),
				u("div", re, [n(T, {
					ref_key: "passwordInput",
					ref: A,
					modelValue: y.value,
					"onUpdate:modelValue": t[1] ||= (e) => y.value = e,
					label: e.$t("autocompletion-mdp.label-password"),
					readonly: !0,
					type: "text",
					onFocusin: I,
					onFocusout: R,
					onKeydown: s(H, ["down"])
				}, null, 8, ["modelValue", "label"]), n(Z, {
					ref_key: "fillPasswordModal",
					ref: M,
					"display-modal": D.value,
					"saved-url": e.$t("autocompletion-mdp.vault.url"),
					"value-to-fill": "************",
					"related-value-to-fill": e.$t("autocompletion-mdp.vault.email"),
					"button-aria-label": e.$t("autocompletion-mdp.button.password-label"),
					onFillInput: B,
					onHideModal: R
				}, null, 8, [
					"display-modal",
					"saved-url",
					"related-value-to-fill",
					"button-aria-label"
				])]),
				n(C, {
					"is-disabled": N.value,
					class: "connect",
					onClick: P
				}, {
					default: g(() => [i(m(e.$t("autocompletion-mdp.connect")), 1)]),
					_: 1
				}, 8, ["is-disabled"])
			]),
			u("a", {
				class: "forgot-link",
				href: "#",
				onClick: c(G, ["prevent"])
			}, m(e.$t("autocompletion-mdp.forgot")), 1),
			n(E, {
				ref: "success-modal",
				content: e.$t("autocompletion-mdp.feedback.content"),
				loop: !1,
				show: b.value,
				title: e.$t("autocompletion-mdp.feedback.title")
			}, null, 8, [
				"content",
				"show",
				"title"
			]),
			n(W, {
				show: O.value,
				onClose: G
			}, null, 8, ["show"])
		]));
	}
}), [["styles", ["*{--text-blue:#122647;--background-blue:#253858;box-sizing:border-box;font-family:Nunito,Roboto,sans-serif;font-size:14px}h1,h2,h3,h4,h5,h6{color:var(--text-blue);font-family:Nunito,sans-serif}h2{color:var(--text-blue);font-size:20px}p,a,span,li{color:var(--text-blue);font-family:Roboto,sans-serif}button{background:var(--background-blue);border-radius:8px;font-size:16px;font-weight:700}button:disabled{background:#c8cfd9}input{background:#f4f5f7;border:#cdd1d9;border-radius:10px}.sr-only{clip-path:inset(50%);white-space:nowrap;border:0;width:1px;height:1px;padding:0;position:absolute;overflow:hidden}html,body,div,span,applet,object,iframe,h1,h2,h3,h4,h5,h6,p,blockquote,pre,a,abbr,acronym,address,big,cite,code,del,dfn,em,img,ins,kbd,q,s,samp,small,strike,strong,sub,sup,tt,var,b,u,i,center,dl,dt,dd,ol,ul,li,fieldset,form,label,legend,table,caption,tbody,tfoot,thead,tr,th,td,article,aside,canvas,details,embed,figure,figcaption,footer,header,hgroup,menu,nav,output,ruby,section,summary,time,mark,audio,video,dialog{font-size:100%;font:inherit;vertical-align:baseline;border:0;margin:0;padding:0}article,aside,details,figcaption,figure,footer,header,hgroup,menu,nav,section{display:block}body{line-height:1}ol,ul{list-style:none}table{border-collapse:collapse;border-spacing:0}*{color:#253858}", ".wrapper[data-v-ffa98bb7]{background:#fff;border-radius:14px;padding:25px;position:relative;box-shadow:0 2px 5px #4a3aff40,inset 0 -2px 5px #4a3aff26,inset 0 1px 1px #ffffff1a,inset 0 3px 4px #dfeeff1a}.wrapper__input[data-v-ffa98bb7]{width:100%;position:relative}[data-v-ffa98bb7] label{margin-top:16px}.title[data-v-ffa98bb7]{align-items:center;gap:8px;font-size:1.25rem;font-weight:700;display:flex}.connect[data-v-ffa98bb7]{width:100%;margin:16px auto;display:block}.forgot-link[data-v-ffa98bb7]{text-align:center;width:100%;font-size:.875rem;display:block}"]], ["__scopeId", "data-v-ffa98bb7"]]);
b.addTranslationsFromGlobResults(/* #__PURE__ */ Object.assign({
	"./locales/de-AT.json": D,
	"./locales/en.json": O,
	"./locales/es-419.json": k,
	"./locales/es.json": A,
	"./locales/fr-BE.json": j,
	"./locales/fr.json": M,
	"./locales/it.json": N,
	"./locales/nl.json": P
})), b.addTranslationsFromGlobResults(/* #__PURE__ */ Object.assign({
	"../common/poi-design-system/unavailable-feature/locales/de-AT.json": F,
	"../common/poi-design-system/unavailable-feature/locales/en.json": I,
	"../common/poi-design-system/unavailable-feature/locales/es-419.json": L,
	"../common/poi-design-system/unavailable-feature/locales/es.json": R,
	"../common/poi-design-system/unavailable-feature/locales/fr-BE.json": z,
	"../common/poi-design-system/unavailable-feature/locales/fr.json": B,
	"../common/poi-design-system/unavailable-feature/locales/it.json": V,
	"../common/poi-design-system/unavailable-feature/locales/nl.json": H
}));
var $ = d(ie, { configureApp(e) {
	b.changeLanguage(document?.documentElement?.lang || navigator.language), e.use(b);
} });
$.prototype.normalizeProps = (e) => ({ titleLevel: x(e.titleLevel) }), window.customElements.define("autocompletion-mdp", $);
//#endregion
